import { Map } from 'immutable';
import { t } from 'i18next';

const IDENTITY_PROVIDER_NAMESPACE_TYPE_ID = 3;
const PROPERTY_MANAGEMENT_SYSTEM_NAMESPACE_TYPE_ID = 4;

export function isUserFromIdpOrPms(identity) {
  if (Map.isMap(identity)) {
    const namespaceTypeId = identity.getIn([
      'namespace',
      'namespaceType',
      'id',
    ]);
    return (
      namespaceTypeId === IDENTITY_PROVIDER_NAMESPACE_TYPE_ID ||
      namespaceTypeId === PROPERTY_MANAGEMENT_SYSTEM_NAMESPACE_TYPE_ID
    );
  }
  if (identity) {
    const namespaceTypeId = identity?.namespace?.namespaceType?.id;
    return (
      namespaceTypeId === IDENTITY_PROVIDER_NAMESPACE_TYPE_ID ||
      namespaceTypeId === PROPERTY_MANAGEMENT_SYSTEM_NAMESPACE_TYPE_ID
    );
  }
  return false;
}

export function parseIdentityProvider(identity) {
  if (Map.isMap(identity)) {
    switch (identity.getIn(['namespace', 'namespaceType', 'modelName'])) {
      case 'identityProvider':
        return identity.getIn([
          'namespace',
          'identityProvider',
          'identityProviderType',
          'name',
        ]);
      case 'propertyManagementSystem':
        return identity.getIn([
          'namespace',
          'propertyManagementSystem',
          'propertyManagementSystemType',
          'name',
        ]);
      case 'org':
        return `Avigilon Alta / ${identity.getIn([
          'namespace',
          'org',
          'name',
        ])}`;
      default:
        return 'Avigilon Alta / Global';
    }
  } else if (identity) {
    switch (identity?.namespace?.namespaceType?.modelName) {
      case 'identityProvider':
        return (
          identity?.namespace?.identityProvider?.identityProviderType?.name ||
          t('Unknown')
        );
      case 'propertyManagementSystem':
        return identity?.namespace?.namespaceType?.name || t('Unknown');
      case 'org':
        return `Avigilon Alta / ${identity?.namespace?.org?.name || t('Global')}`;
      default:
        return `Avigilon Alta / ${t('Global')}`;
    }
  } else {
    return `Avigilon Alta / ${t('Global')}`;
  }
}
